import { Icon, LinkButton } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo } from 'react';
import type { NaicsLinkProps as Props } from './types';

export const NaicsLink = memo(({ className }: Props) => {
  const link = 'https://www.census.gov/naics/';

  return (
    <Stack direction="row" alignItems="center" gap={0.5}>
      <LinkButton
        className={classnames('NaicsLink', className)}
        variant="text"
        href={link}
      >
        <Typography variant="body4" color="grey.700" fontWeight={500}>
          NAICS Lists
        </Typography>
      </LinkButton>
      <Icon size={16} name="external-link" color="grey.700" />
    </Stack>
  );
});

NaicsLink.displayName = 'NaicsLink';
